import React from 'react';
import { Accordion } from 'react-bootstrap';
import ProductDetailsFields from './ProductDetailsFields';
import ProductImagesTab from './ProductImagesTab';
import ProductFeaturesTab from './ProductFeaturesTab';
import ProductSpecificationsTab from './ProductSpecificationsTab';
import ProductDetailTabsTab from './ProductDetailTabsTab';

export const PRODUCT_EDIT_SECTIONS = [
  { key: 'details', title: 'Product Details', requiresProduct: false },
  { key: 'images', title: 'Upload Images', requiresProduct: true },
  { key: 'features', title: 'Product Features', requiresProduct: true },
  { key: 'specs', title: 'Product Specifications', requiresProduct: true },
  { key: 'detail-tabs', title: 'Detail Page Tabs', requiresProduct: true },
];

export const getEnabledSectionKeys = (childTabsEnabled) =>
  PRODUCT_EDIT_SECTIONS
    .filter((section) => !section.requiresProduct || childTabsEnabled)
    .map((section) => section.key);

const isSectionOpen = (activeKey, sectionKey) => {
  if (Array.isArray(activeKey)) return activeKey.includes(sectionKey);
  return activeKey === sectionKey;
};

function ProductEditAccordion({
  activeKey,
  onSelect,
  expandAll,
  onExpandAllChange,
  childTabsEnabled,
  formData,
  productId,
  slugManual,
  onSlugManualChange,
  onDataChange,
  onRefresh,
  onFeatureOrderChange,
  featureOrderSaveToken,
  onSpecificationOrderChange,
  specOrderSaveToken,
  onDetailTabsChange,
  detailTabsSaveToken,
  tabTypes,
}) {
  const renderSectionBody = (key) => {
    const section = PRODUCT_EDIT_SECTIONS.find((item) => item.key === key);
    if (section?.requiresProduct && !childTabsEnabled) return null;
    if (!isSectionOpen(activeKey, key)) return null;

    switch (key) {
      case 'details':
        return (
          <ProductDetailsFields
            formData={formData}
            sendDataToParent={onDataChange}
            slugManual={slugManual}
            onSlugManualChange={onSlugManualChange}
          />
        );
      case 'images':
        return (
          <ProductImagesTab
            productId={productId}
            images={formData.Images}
            onRefresh={onRefresh}
          />
        );
      case 'features':
        return (
          <ProductFeaturesTab
            productId={productId}
            features={formData.Features}
            onRefresh={onRefresh}
            onOrderChange={onFeatureOrderChange}
            featureOrderSaveToken={featureOrderSaveToken}
          />
        );
      case 'specs':
        return (
          <ProductSpecificationsTab
            productId={productId}
            specifications={formData.Specifications}
            onRefresh={onRefresh}
            onOrderChange={onSpecificationOrderChange}
            specOrderSaveToken={specOrderSaveToken}
          />
        );
      case 'detail-tabs':
        return (
          <ProductDetailTabsTab
            detailTabs={formData.DetailTabs}
            tabTypes={tabTypes}
            onTabsChange={onDetailTabsChange}
            detailTabsSaveToken={detailTabsSaveToken}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="expand-all-product-sections"
            checked={!!expandAll}
            onChange={(e) => onExpandAllChange(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="expand-all-product-sections">
            Expand all sections
          </label>
        </div>
      </div>
      <Accordion
        activeKey={activeKey}
        onSelect={onSelect}
        alwaysOpen={expandAll}
        className="accordion accordion-primary"
      >
        {PRODUCT_EDIT_SECTIONS.map((section) => {
          const disabled = section.requiresProduct && !childTabsEnabled;
          return (
            <Accordion.Item key={section.key} eventKey={section.key}>
              <Accordion.Header
                onClick={(e) => {
                  if (disabled) e.preventDefault();
                }}
              >
                <span
                  className={disabled ? 'text-muted' : undefined}
                  title={disabled ? 'Save product details first' : undefined}
                >
                  {section.title}
                </span>
              </Accordion.Header>
              <Accordion.Body>{renderSectionBody(section.key)}</Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </>
  );
}

export default ProductEditAccordion;
